<script setup lang="ts">
const props = defineProps({
	width: {
		type: String,
		default: '45',
	},
	height: {
		type: String,
		default: '45',
	},
	color: {
		type: String,
		default: ICON_COLOR.DEFAULT,
	},
});

const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);
</script>
<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		viewBox="0 0 45 45"
		fill="none"
	>
		<circle
			cx="22.5"
			cy="22.5"
			r="22.5"
			transform="rotate(180 22.5 22.5)"
			:fill="iconColor"
			fill-opacity="0.4"
		/>
		<path
			d="M26.002 30L18.502 22.5L26.002 15"
			stroke="white"
			stroke-width="4"
		/>
	</svg>
</template>
